const TranslateApi = {
    getIndex: '/crud/translates',
    getKeys: '/crud/translates/keys',
    change: '/crud/translates/change',
}

export default TranslateApi;
